;(function () {
  'use strict'

  angular.module('admin.withdrawals.service', []).factory('WithdrawalsService', WithdrawalsService)

  /** @ngInject */
  function WithdrawalsService($http, $q, API) {
    function list(start, limit, dur) {
      var defered = $q.defer()

      $http
        .get(
          API.API_URL +
            'admin/withdrawals/previous?start=' +
            start +
            '&limit=' +
            limit +
            '&dur=' +
            dur,
        )
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function listPending(start, limit, dur) {
      var defered = $q.defer()

      $http
        .get(
          API.API_URL +
            'admin/withdrawals/pending?start=' +
            start +
            '&limit=' +
            limit +
            '&dur=' +
            dur,
        )
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function listUserWithdrals(userId, start, limit, dur) {
      var defered = $q.defer()

      $http
        .get(
          API.API_URL +
            'admin/users/' +
            userId +
            '/withdrawals?start=' +
            start +
            '&limit=' +
            limit +
            '&dur=' +
            dur,
        )
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function approve(userId) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'admin/users/' + userId + '/withdrawals/pending/execute')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function approveAll() {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'admin/withdrawals/pending/execute')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function changeAmount(id, body) {
      var defered = $q.defer()

      $http
        .put(API.API_URL + 'admin/withdrawals/' + id + '/amount', body)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function remove(id) {
      var defered = $q.defer()

      $http
        .delete(API.API_URL + 'admin/withdrawals/' + id)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    return {
      list,
      listPending,
      listUserWithdrals,
      approve,
      approveAll,
      changeAmount,
      remove,
    }
  }
})()
